import { createFileRoute } from "@tanstack/react-router";
import BlogList from "@/components/blog/BlogList";
import { getArticles } from "@/lib/sanity.server";
import CTA from "@/components/LandingPage/CTA";

const parsePositivePage = (value: unknown) => {
  const page = typeof value === "number" ? value : typeof value === "string" ? Number(value) : 1;
  return Number.isFinite(page) && page > 0 ? Math.floor(page) : 1;
};

export const Route = createFileRoute("/$lang/blog")({
  validateSearch: (search) => ({
    page: parsePositivePage(search.page),
  }),
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: async ({ deps: { page } }) => {
    const pageSize = 9;
    const data = await getArticles({ data: { page, pageSize } });
    return { articles: data.articles, pagination: data.pagination };
  },
  component: LangBlogPage,
});

function LangBlogPage() {
  const { articles, pagination } = Route.useLoaderData();
  return (
    <div className="min-h-screen bg-white dark:bg-black transition-colors duration-300">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-16">
        <BlogList articles={articles} pagination={pagination} />
      </section>
      <CTA />
    </div>
  );
}
